import React, { useState, useEffect, useContext } from "react";
import InternetChecking from "../../Student/Reusablecomponents/Network";
import { LoadContext } from "../../ReusableComponents/LoadingContex";
import axiosInstance from "../../ReusableComponents/Axios";
import { Institute } from "../../ReusableComponents/NCLAdminDropdowns";
import DataTable from "../../Student/Reusablecomponents/DataTable/DataTable";
const RWNES = () => {
  const { SetLoad } = useContext(LoadContext);
  const [SInst, SetSInst] = useState();
  const [NEStudents, SetNEStudents] = useState([]);
  const Columns = [
    { name: "Student Id", selector: "loginId", sortable: true },
    {
      name: "Student Name",
      selector: "studentName",
      sortable: true,
      cell: (row) => `${row.firstName} ${row.lastName}`,
    },
    { name: "Grade", selector: "grade", sortable: true },
    { name: "Section", selector: "section", sortable: true },
  ];
  useEffect(() => {
    GetNEStudents();
  }, [SInst]);
  const GetNEStudents = async () => {
    SetLoad((prev) => !prev);
    try {
      const res = await axiosInstance.get(
        `/NCLAdmin/GetStudentsWithNeitherElectiveByInstitute?InstituteId=${SInst?.Value}`,
      );
      console.log(res.data);
      SetNEStudents(res.data);
    } catch (err) {
      console.log(err);
    } finally {
      SetLoad((prev) => !prev);
    }
  };
  return (
    <div className="TeacherBgImage">
      <InternetChecking />
      <div className="MainHeading">Registrations with no Elective Subject</div>
      <Institute
        className="NCLDropdown w-50"
        labelname={<div className="DropdownHeader">Institutes </div>}
        Displayname="Select Institute"
        SOption={SInst?.Value}
        onChange={(e) => {
          SetSInst(e);
        }}
      />

      <DataTable
        data={NEStudents}
        columns={Columns}
        className="NCLDataTable Card mt-3"
      />
    </div>
  );
};
export default RWNES;
